export default __webpack_public_path__ + "static/media/restyling-kits.c13c7cc4.glb";